import { Pipe, PipeTransform } from '@angular/core';
import { compareFn } from 'app/shared/models';


@Pipe({
    name: 'orderBy',
})
export class OrderByPipe<T> implements PipeTransform {

    transform(value: T[], field: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
        return [...value].sort((a, b) => compareFn(a, b, field, order === 'desc'));
    }
}
